<template>
  <LoadingModal v-if="loading"/>

  <div class="pageContent" v-else>
    <div class="detailBox">
      <div class="tabs">
        <div class="filler"></div>
        <div
          class="tab"
          :class="{'is-active': activeTab === 'students'}"
          @click="switchFocus('students')"
        >Studenti</div>
        <div
          class="tab"
          :class="{'is-active': activeTab === 'teachers'}"
          @click="switchFocus('teachers')"
        >Učitelé</div>
        <div class="filler"></div>
      </div>

      <div class="management">
        <div class="management-content" v-if="activeTab === 'students'">
          <div class="level">
            <div class="level-left"></div>
            <div class="level-right">
              <button class="btn spaceless isBlue" @click="openAddUserModal('student')">
                <icon type="plus" size="16"/>Přidat studenta
              </button>
            </div>
          </div>

          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                :class="{'is-disabled': !student.enabled}"
                v-for="student in students"
                v-if="edit.username !== student.username"
                :key="student.username"
              >
                <td>{{ student.first_name }} {{ student.last_name }}</td>
                <td></td>
                <td></td>
                <td class="table-buttons" v-if="student.enabled">
                  <button
                    class="btn spaceless isBlue"
                    v-if="!edit.processing"
                    @click="startEdit(student)"
                  >
                    <icon type="edit-2" size="16"/>Upravit
                  </button>
                  <button
                    class="btn spaceless isCarnation"
                    @click="openEnableModal(student, false)"
                  >
                    <icon type="user-x" size="16"/>Deaktivovat
                  </button>
                </td>

                <td class="table-buttons" v-else>
                  <button class="btn spaceless isTurquoise" @click="openEnableModal(student, true)">
                    <icon type="user-check" size="16"/>Aktivovat
                  </button>
                </td>
              </tr>

              <tr v-else>
                <td>
                  <input class="tabled" type="text" placeholder="jméno" v-model="edit.firstName">
                </td>
                <td>
                  <input class="tabled" type="text" placeholder="příjmení" v-model="edit.lastName">
                </td>
                <td>
                  <input class="tabled" type="text" :value="edit.username" disabled>
                </td>
                <td class="table-buttons">
                  <button class="btn spaceless isGreen" @click="endEdit()">
                    <icon type="check" size="16"/>Potvrdit
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="management-content" v-else>
          <div class="level">
            <div class="level-left"></div>
            <div class="level-right">
              <button class="btn spaceless isBlue" @click="openAddUserModal('teacher')">
                <icon type="plus" size="16"/>Přidat učitele
              </button>
            </div>
          </div>

          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="teacher in teachers"
                v-if="edit.username !== teacher.username"
                :key="teacher.username"
              >
                <td>{{ teacher.degree }} {{ teacher.first_name }} {{ teacher.last_name }}</td>
                <td></td>
                <td></td>
                <td class="table-buttons">
                  <button
                    class="btn spaceless isBlue"
                    v-if="!edit.processing"
                    @click="startEdit(teacher)"
                  >
                    <icon type="edit-2" size="16"/>Upravit
                  </button>
                </td>
              </tr>

              <tr v-else>
                <td>
                  <input class="tabled" type="text" placeholder="jméno" v-model="edit.firstName">
                </td>
                <td>
                  <input class="tabled" type="text" placeholder="příjmení" v-model="edit.lastName">
                </td>
                <td>
                  <input class="tabled" type="text" :value="edit.username" disabled>
                </td>
                <td class="table-buttons">
                  <button class="btn spaceless isGreen" @click="endEdit()">
                    <icon type="check" size="16"/>Potvrdit
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <EnableModal
        :shown="enableModalShown"
        :meta="passToModal"
        @closeSelf="closeEnableModal()"
        @validated="takeAction()"
      />

      <InfoModal
        :shown="infoModalShown"
        :confUsername="confUsername"
        @closeSelf="closeInfoModal()"
        @confirmed="updateUsername()"
      />

      <AddUserModal
        :shown="addUserModalShown"
        :userType="userType"
        @closeSelf="closeAddUserModal()"
        @beforeAdd="processAdd($event)"
      />
    </div>
  </div>
</template>

<script>
import { fetchUsers, modifyUser, renameUser, addUser } from '../http';
import LoadingModal from '../components/LoadingModal';
import EnableModal from '../components/EnableModal';
import InfoModal from '../components/InfoModal';
import AddUserModal from '../components/AddUserModal';

export default {
  components: {
    LoadingModal,
    EnableModal,
    InfoModal,
    AddUserModal
  },

  data() {
    return {
      loading: true,
      activeTab: null,
      students: null,
      teachers: null,
      enableModalShown: false,
      passToModal: null,
      infoModalShown: false,
      confUsername: null,
      edit: {
        saved: {
          firstName: null,
          lastName: null
        },
        processing: false,
        firstName: null,
        lastName: null,
        username: null
      },
      addUserModalShown: false,
      userType: null
    };
  },

  methods: {
    switchFocus(to) {
      this.activeTab = to;
      window.sessionStorage.setItem('activeTab', to);

      this.edit.username = null;
      this.edit.firstName = null;
      this.edit.lastName = null;

      this.edit.processing = false;
    },

    openEnableModal(user, enable) {
      this.passToModal = { user, enable };
      this.enableModalShown = true;
    },

    closeEnableModal() {
      this.passToModal = null;
      this.enableModalShown = false;
    },

    openInfoModal(username) {
      this.confUsername = username;
      this.infoModalShown = true;
    },

    async closeInfoModal() {
      this.confUsername = null;

      this.edit.username = null;
      this.edit.firstName = null;
      this.edit.lastName = null;

      this.edit.processing = false;
      this.infoModalShown = false;
    },

    openAddUserModal(userType) {
      this.userType = userType;
      this.addUserModalShown = true;
    },

    closeAddUserModal() {
      this.addUserModalShown = false;
    },

    startEdit(student) {
      this.edit.saved.firstName = student.first_name;
      this.edit.saved.lastName = student.last_name;

      this.edit.username = student.username;
      this.edit.firstName = student.first_name;
      this.edit.lastName = student.last_name;

      this.edit.processing = true;
    },

    endEdit() {
      this.edit.firstName = this.edit.firstName.trim();
      this.edit.lastName = this.edit.lastName.trim();

      if (
        this.edit.firstName !== this.edit.saved.firstName ||
        this.edit.lastName !== this.edit.saved.lastName
      ) {
        this.openInfoModal(this.edit.username);
      } else {
        this.edit.username = null;
        this.edit.firstName = null;
        this.edit.lastName = null;

        this.edit.processing = false;
      }

      this.edit.saved.firstName = null;
      this.edit.saved.lastName = null;
    },

    async processAdd(payload) {
      await addUser(payload);
      await location.reload(true);
    },

    async updateUsername() {
      await renameUser(this.edit.username, this.edit.firstName, this.edit.lastName);
      await this.closeInfoModal();
      await location.reload(true);
    },

    async takeAction() {
      const username = this.passToModal.user.username;
      const enable = this.passToModal.enable;

      await this.closeEnableModal();
      await modifyUser(username, enable ? 'enable' : 'disable');
      await location.reload(true);
    }
  },

  async created() {
    try {
      const {
        data: { data }
      } = await fetchUsers();

      this.students = [
        ...data.students
          .filter(student => student.enabled)
          .sort((a, b) => a.last_name.localeCompare(b.last_name)),
        ...data.students
          .filter(student => !student.enabled)
          .sort((a, b) => a.last_name.localeCompare(b.last_name))
      ];

      this.teachers = data.teachers.sort((a, b) => a.last_name.localeCompare(b.last_name));
    } catch (e) {
      console.error(e);
    } finally {
      this.activeTab = sessionStorage.getItem('activeTab') || 'students';
      this.loading = false;
    }
  }
};
</script>

<style lang="sass" scoped>
@import '../styles/login.sass'
@import '../styles/buttons.sass'

input
  margin-bottom: 0

  &:focus
    background: #F9FAFC

  &[disabled]
    cursor: not-allowed

h2.is-blank
  opacity: .25

h2.is-title
  margin-bottom: .5rem

h6
  color: gray
  font-weight: normal

.detailBox
  background: white
  box-shadow: 0 2px 3px rgba(10,10,10, .1), 0 0 0 1px rgba(10,10,10, .1)
  padding: 3.25rem 0 0
  margin: 1.75rem 0

// fix 1px mishap

.tabs
  width: 100%
  display: flex
  justify-content: center
  margin: 0

  & .filler
    flex: 1 0 auto
    background: #F9FAFC

  & .tab
    height: 48px
    line-height: 48px
    padding: 0 1rem
    cursor: pointer
    background: #F9FAFC

    &.is-active
      background: #f0f1f3
      font-weight: bold

    &:not(.is-active):hover
      background: lighten(#f0f1f3, 4%)

.content table thead th, .table thead th, .content table th, .table th, .content table td, .table td
  border: 0

.management
  padding: 2.25rem 10%
  background: #f0f1f3

  & .table
    background: transparent

    &-buttons
      display: flex
      justify-content: flex-end
      align-items: center
      height: 60px

    & tr.is-disabled > td:not(:last-child)
      opacity: .35

    & tr > td
      line-height: 40px
      border-top: 1px solid #3c48582e !important

    & tr:last-child > td
      border-bottom: 1px solid #3c48582e !important

  & th

    &:first-child, &:nth-child(2)
      width: 25%

    &:last-child
      width: 35%

</style>
